/* ARTIST WORLDS: progressive enhancement (shared by every World). Pass 2.
   The page is complete without this file (the archive filters are pure CSS).
   A script-deferral app on this store delays every script by about 6 s, so
   nothing here may be needed for reading, navigating or buying.
   Adds: one-shot wipes and type assembly for elements still below the fold;
   the route line; the timeline rail and act-bar state; the Vertigo close
   reading (spots switch one large detail); the before/after slider; archive
   result announcements and "Available" deep links; dataLayer events (GTM/GA4,
   no new vendor). Phase 3 adds: stagger indexes, scroll progress (--p),
   tone journeys, signature-lab links and the archive re-shuffle.
   Reduced motion: classes still apply, CSS removes motion. */
(function () {
  var world = document.querySelector('.aw[data-world]');

  function push(ev, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev, aw_world: world ? world.getAttribute('data-world') : null };
      for (var k in data) o[k] = data[k];
      window.dataLayer.push(o);
    } catch (e) {}
  }

  /* PDP pages: only the module's links are tracked. */
  if (!world) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-aw-track="pdp_to_world"]');
      if (a) push('aw_pdp_to_world', { aw_target: a.getAttribute('data-aw-world'), aw_src: a.getAttribute('data-aw-src') });
    });
    return;
  }
  if (!('IntersectionObserver' in window)) return;
  world.classList.add('aw-js');
  push('aw_view', {});

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Stagger groups: each child gets its order index ---- */
  world.querySelectorAll('[data-aw-stagger]').forEach(function (el) {
    Array.prototype.forEach.call(el.children, function (c, i) { if (!c.style.getPropertyValue('--i')) c.style.setProperty('--i', i); });
  });

  /* ---- One-shot reveals, only for elements still below the fold ---- */
  var vh = window.innerHeight;
  var revealers = world.querySelectorAll('[data-aw-cut], [data-aw-route], .aw-type-card, [data-aw-stagger]');
  var rio = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      rio.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -18% 0px' });
  revealers.forEach(function (el) {
    if (el.getBoundingClientRect().top > vh) { el.classList.add('aw-pre'); rio.observe(el); }
  });

  /* ---- Scroll progress (--p, 0..1) for scroll-linked scenery ----
     data-aw-progress="exit": 0 while the element sits at the top of the
     viewport, 1 once it has scrolled fully out. Otherwise 0 as it enters at
     the bottom, 1 as it leaves at the top. */
  var prog = world.querySelectorAll('[data-aw-progress]');
  if (prog.length && !reduce) {
    var ticking = false;
    var upd = function () {
      ticking = false;
      var h = window.innerHeight;
      prog.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var p = el.getAttribute('data-aw-progress') === 'exit' ? -r.top / Math.max(1, r.height) : (h - r.top) / (h + r.height);
        el.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(3));
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---- Tone journeys: the section takes the colour of the stop in view ---- */
  world.querySelectorAll('[data-aw-tones]').forEach(function (sec) {
    var stops = sec.querySelectorAll('[data-aw-tone]');
    if (!stops.length) return;
    sec.setAttribute('data-tone', stops[0].getAttribute('data-aw-tone'));
    var tio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) sec.setAttribute('data-tone', en.target.getAttribute('data-aw-tone')); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    stops.forEach(function (s) { tio.observe(s); });
  });

  /* ---- Act bar and timeline rail state + act analytics ---- */
  function wireCurrent(linkSel, targetSel, margin, evName) {
    var links = {};
    world.querySelectorAll(linkSel).forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.id;
        if (!links[id]) return;
        for (var k in links) links[k].setAttribute('aria-current', k === id ? 'true' : 'false');
        if (evName && !seen[id]) { seen[id] = 1; push(evName, { aw_act: id }); }
      });
    }, { rootMargin: margin });
    world.querySelectorAll(targetSel).forEach(function (t) { io.observe(t); });
  }
  wireCurrent('.aw-nav a[href^="#act-"]', '[data-aw-act]', '-45% 0px -50% 0px', 'aw_act');
  wireCurrent('.aw-works__rail a', '[data-aw-scene]', '-40% 0px -55% 0px', null);

  /* ---- Vertigo close reading: one large detail at a time ---- */
  world.querySelectorAll('[data-aw-reading]').forEach(function (box) {
    var spots = box.querySelectorAll('[data-aw-spot]');
    var details = box.querySelectorAll('[data-aw-detail]');
    function select(n, user) {
      spots.forEach(function (s) { s.setAttribute('aria-current', s.getAttribute('data-aw-spot') === n ? 'true' : 'false'); });
      details.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-aw-detail') === n); });
      if (user) push('aw_detail', { aw_detail: n });
    }
    select('1', false);
    spots.forEach(function (s) {
      var n = s.getAttribute('data-aw-spot');
      s.addEventListener('click', function (e) { e.preventDefault(); select(n, true); });
      s.addEventListener('mouseenter', function () { select(n, false); });
      s.addEventListener('focus', function () { select(n, false); });
    });
  });

  /* ---- Before/after comparison ---- */
  world.querySelectorAll('[data-aw-compare]').forEach(function (c) {
    var r = c.querySelector('input[type="range"]');
    if (!r) return;
    var told = false;
    function set() { c.style.setProperty('--pos', r.value + '%'); if (!told) { told = true; push('aw_compare', {}); } }
    r.addEventListener('input', set);
  });

  /* ---- Archive: announce results; "Available" deep links ---- */
  var arch = world.querySelector('[data-aw-archive]');
  if (arch) {
    var status = arch.querySelector('[data-aw-archive-status]');
    function announce(user) {
      var shown = Array.prototype.filter.call(arch.querySelectorAll('.aw-archive__item'), function (li) { return li.offsetParent !== null; }).length;
      var f = (arch.querySelector('input[name^="aw-f-"]:checked') || {}).value;
      var sg = (arch.querySelector('input[name^="aw-s-"]:checked') || {}).value;
      var label = f === 'available' ? 'available now' : f === 'sold' ? 'sold, in the archive' : 'in the archive';
      if (sg === 'hand') label = 'hand-signed, ' + label;
      else if (sg === 'plate') label = 'plate-signed, ' + label;
      else if (sg === 'after') label = 'published after the artist, ' + label;
      if (status) status.textContent = 'Showing ' + shown + ' poster' + (shown === 1 ? '' : 's') + ' ' + label + '.';
      if (user) push('aw_filter', { aw_filter: f, aw_count: shown });
    }
    function shuffle() {
      if (reduce) return;
      arch.classList.remove('is-shuffle'); void arch.offsetWidth; arch.classList.add('is-shuffle');
    }
    arch.addEventListener('change', function () { announce(true); shuffle(); });
    world.querySelectorAll('[data-aw-sig]').forEach(function (a) {
      a.addEventListener('click', function () {
        var r = arch.querySelector('input[name^="aw-s-"][value="' + a.getAttribute('data-aw-sig') + '"]');
        if (r) { r.checked = true; announce(true); shuffle(); push('aw_siglab_go', { aw_sig: a.getAttribute('data-aw-sig') }); }
      });
    });
    function showAvailable() {
      var r = arch.querySelector('input[value="available"]');
      if (r && !r.checked) { r.checked = true; announce(true); }
    }
    world.querySelectorAll('[data-aw-filter="available"]').forEach(function (a) { a.addEventListener('click', showAvailable); });
    if (location.hash === '#available') showAvailable();
  }

  /* ---- Outbound clicks ---- */
  world.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-aw-track]');
    if (!a) return;
    push('aw_' + a.getAttribute('data-aw-track'), { aw_src: a.getAttribute('data-aw-src'), aw_state: a.getAttribute('data-aw-state'), aw_href: a.getAttribute('href') });
  });
})();
